/* eslint-disable */
const LangErrorMessage = {
	"_shared.form.validate._emailIsNotValid": [
		"Please enter a valid Email address",
		"សូម​បំពេញ​អាសយដ្ឋាន​អ៊ីម៉ែល ​ដែល​ត្រឹមត្រូវ",
	],
	"_shared.form.validate._passwordIsNotValid": [
		"Please enter a valid Password",
		"សូម​បំពេញ​លេខ​សម្ងាត់​ ដែល​ត្រឹមត្រូវ",
	],
	"_shared.form._required": ["* Required", "* តម្រូវ​ឲ្យ​​បំពេញ"],
	"_shared.form.validate._required": [
		"${ label } is required",
		"${ label }​ តម្រូវ​ឲ្យ​​បំពេញ",
	],
	"_shared.form.validate._minLength": [
		"Must be at least ${minLength} characters",
		"ត្រូវ​តែ​​ចំនួន​យ៉ាង​តិច​​ ${minLength} តួ​",
	],
	"_shared.form.validate._fixedLength": [
		"Must be ${fixedLength} characters",
		"ត្រូវ​តែ​​ចំនួន​ ${fixedLength} តួ​",
	],
	"_shared.form.validate.card._fixedLength": [
		"Invalid Card Number",
		"Invalid Card Number",
	],
	"_shared.form.validate.code._fixedLength": [
		"Invalid Security Code",
		"Invalid Security Code",
	],
	"_shared.form.validate._maxLength": [
		"Must be no more than ${maxLength} characters",
		"មិន​ត្រូវ​​វែង​ជាង ${maxLength}​ តួ​",
	],
	"_shared.form.validate._integer": ["Please fill in number", "សូម​បញ្ចូល​លេខ"],
	"_shared.form.validate._notMatch": [
		"Do not match ${match}",
		"មិន​ដូច​គ្នា​ ${match}",
	],
	"_shared.form.validate._invalidDate": [
		"The birthday is invalid",
		"សូម​បំពេញ ​ថ្ងៃ​ខែ​កំណើត​ ",
	],
	"_shared.form.validate._allowFileExtensions": [
		"Please upload FileFormats: *.jpeg, *.jpg, *.gif, *png, *pdf",
		"សូម​បញ្ចូល​ឯកសារ​​​ទម្រង់ជា​ *.jpeg, *.jpg, *.gif, *png, *pdf",
	],

	"_shared.form.validate._moreThanMaxFileSize": [
		"Must be not more than ${maxSize} Mb",
		"ឯកសារ​មិន​ត្រូវ​ទំហំ​ធំ​ជាង ${maxSize} Mb",
	],
	"_shared.form.validate._noSpecialChars": [
		"Only enter alphabets",
		"បំពេញបាន​តែ​អក្សរ​​​ឡាតាំ​ងប៉ុណ្ណោះ​",
	],
	"_shared.form.validate._noVnChars": [
		"Only enter alphabets",
		"បំពេញបាន​តែ​អក្សរ​​​ឡាតាំ​ងប៉ុណ្ណោះ​",
	],
	"_shared.page.params._invalidCardNo": [
		"Invalid Card No!",
		"លេខ​កាត​​ និង​លេខ​កូដ មិន​ត្រឹម​ត្រូវ​",
	],
	"_shared.page.params._email&telIsNotValid": [
		"Please enter a valid Email address or Phone number",
		"សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែល ឬលេខទូរស័ព្ទដែលមានសុពលភាព​",
	],
}

export default LangErrorMessage



// WEBPACK FOOTER //
// ./src/resources/general/LangErrorMessage.js